/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-07-12 11:45:56
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-13 14:18:47
 */
import { Button } from "antd";
import React from "react";
import styles from "./HealthPrisonAnaylse.module.css";

interface SkeletonProps {
  infoMsg?: string;
  isSelect?: () => void;
}

export const Skeleton: React.FC<SkeletonProps> = ({ infoMsg, isSelect }) => {
  return (
    <div className={styles.skeleton}>
      <div>
        {isSelect ? (
          <Button type='link' style={{ color: '#999', fontSize: '14px' }}>
            暂无数据，请先
            <span style={{ color: '#1890ff' }} onClick={isSelect}>
              选择卫健委(局)
            </span>
          </Button>
        ) : (
          <>{infoMsg}</>
        )}
      </div>
    </div>
  )
};
